<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.gasFlowParaEdit')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/gasFlowPara">
              <span>{{$t('tlt.gasFlowPara')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
              <router-link to="/prd/gasFlowPara/edit">
                <span>{{$t('tlt.gasFlowParaEdit')}}</span>
              </router-link>
          </li>
        </ul>
      </div>
      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList(moduleName)"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" @click="MMFSave(moduleName)">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <div class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <mmf-edit :entity="moduleName"></mmf-edit>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import MmfEdit from "@/components/MmfEdit";
import { mapActions } from "vuex";

export default {
  data: function() {
    return {
      moduleName: "gasFlowPara"
    };
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFCheckState"]),
  },
  components: {
    MmfEdit
  }
};
</script>

